import * as React from 'react';
import {
    ICustomerPortalService,
    Policy,
    resourcesHelper, Types, CLAIM_TYPE_OTHER
} from "@falcon/services";
import {setSessionStorage,} from "../../../../../CommonFunctions";
import {lazyInject} from "@athena-portal/core";
import {Overlay} from "@athena-portal/components";
import {ButtonLink} from "../../../../../components/navigation/ButtonLink";
import {Types as JourneyCoreTypeDefs, ILookupService} from "@athena-portal/plugin-journey";
import * as moment from "moment";
import {AnnualHomeDocumentListModal} from "@falcon/plugin-falcon-journey";
import {HomePolicySummary} from "./HomePolicySummary";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {RouteComponentProps} from "react-router-dom";

interface IPageParams {
    policyNumber: string;
}

export interface IProps extends RouteComponentProps<IPageParams> {
    policy: Policy;
}

export class HomePolicySummaryPanel extends React.Component<IProps, {}> {
    protected pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    protected customerPortalService: ICustomerPortalService;

    @lazyInject(JourneyCoreTypeDefs.LookupService)
    protected lookupService: ILookupService;

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Policy summary");
    }

    public render(): React.ReactNode {
        const claimsLink = this.props.policy.interaction?.annualHomeFixedAddons?.homeEmergency
            ? `/dashboard/annualHome/${this.props.policy.policyNumber}/claims/new`
            : `/dashboard/annualHome/${this.props.policy.policyNumber}/claims/details`;
        if (!this.props.policy.interaction?.annualHomeFixedAddons?.homeEmergency) {
            setSessionStorage("claim", CLAIM_TYPE_OTHER);
        }

        if (!this.props.policy) {
            return <Overlay show={true}/>
        } else {
            const policy: Policy = this.props.policy;
            const policyStarted = policy && moment(policy.endDate).isAfter(moment(policy.startDate));
            return (
                <React.Fragment>
                {this.renderPolicyNumber()}
                    <div className="section-panel your-cover-panel padding-top-bot-50">
                        <img className="main-icon policy-icon"
                             src={`/${resourcesHelper.THEME}/img/policy-summary.png`} alt="Policy summary icon"/>
                        <HomePolicySummary policyNumber={this.props.policy.policyNumber} policy={policy} editAddress={false}/>
                    </div>
                    <AnnualHomeDocumentListModal
                        coverTier={policy.interaction.coverTier}
                        policyDate={new Date(policy.startDate)}
                        withTitle={true}
                        annualHomeFixedAddons={policy.interaction.annualHomeFixedAddons}
                    />
                    {policyStarted && <ButtonLink
                        primaryNoArrow={true}
                        className="make-a-claim"
                        to={claimsLink}>
                        Make a claim
                    </ButtonLink>}
                </React.Fragment>
            )
        }
    }

    public renderPolicyNumber(): JSX.Element {
        return (
            <div className="page-heading-white">
                <span className="font-weight-light">Policy no: </span>
                {this.props.policy.policyNumber}
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/annual/home/policySummary/HomePolicySummaryPanel.tsx